<template>
  <a-config-provider :locale="locale">
    <a-layout>
      <AppHeader />
      <a-layout-content>
        <!---全局loading--->
        <a-spin :spinning="false">
          <!--- 路由 -->
          <RouterView :key="key"/>
        </a-spin>
      </a-layout-content>
    </a-layout>
  </a-config-provider>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { useRoute } from 'vue-router'
import AppHeader from '@/components/layout/AppHeader.vue'
const route = useRoute()
const key = computed(() => {
  return route.name
})

dayjs.locale('zh-cn')
const locale = ref(zhCN)
</script>

<style scoped>
#components-layout-demo-side .logo {
  height: 32px;
  margin: 16px;
  background: rgba(255, 255, 255, 0.3);
}

.site-layout .site-layout-background {
  background: #fff;
}
/* [data-theme='dark'] .site-layout .site-layout-background {
  background: #141414;
} */
</style>
